const FACEBOOK_ID = '2728572604024288'

export async function initFacebook() {
  return new Promise((resolve) => {
    if (!document.getElementById('FacebookPixelScript')) {
      // eslint-disable-next-line no-unused-expressions
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq)
          return
        n = f.fbq = function () {
          n.callMethod
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            ? n.callMethod.apply(n, arguments)
            // eslint-disable-next-line prefer-rest-params
            : n.queue.push(arguments)
        }
        if (!f._fbq)
          f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = !0
        t.src = v
        t.id = 'FacebookPixelScript'
        t.onload = () => {
          resolve()
        }
        s = b.getElementsByTagName(e)[0]
        s.parentNode.insertBefore(t, s)
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'))
      window.fbq('init', FACEBOOK_ID)
    }
    else
      resolve()
  })
}
